import React, { useState } from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";

import { translate as t } from "infrastructure/translate/localization";

import StepHeader from "../../components/StepHeader";
import Table from "../../../../../Table";
import EmptyDataForTableMessage from "../../components/EmptyDataForTableMessage";
import TableDataSpinner from "../../components/TableDataSpinner";
import StepFooter from "../../components/StepFooter";
import { getColumns, getData } from "./utils";

export default function PendingPayments({
  content,
  data,
  isLoading,
  employees,
  currentStep,
  target,
}) {
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <Grid item container xs={12}>
      <StepHeader
        {...content}
        searchCallback={setSearchTerm}
        isLoading={isLoading}
      />

      {isLoading ? (
        <TableDataSpinner />
      ) : (
        <>
          {data?.pendingPayments?.length > 0 ? (
            <Table
              columns={getColumns()}
              data={getData({
                data: data?.pendingPayments,
                searchTerm,
              })}
              withBreakDown
            />
          ) : (
            <EmptyDataForTableMessage
              message={`${t(
                "common-messages.empty-data-for-selected-employees",
                {
                  dataName: t(
                    "employees-section.pending-payments"
                  ).toLowerCase(),
                }
              )}.`}
            />
          )}
        </>
      )}
      <StepFooter
        isLoading={isLoading}
        currentStep={currentStep}
        employees={employees}
        hasNoData={data?.pendingPayments?.length === 0}
        target={target}
      />
    </Grid>
  );
}

PendingPayments.defaultProps = {
  employees: [],
  data: undefined,
  isLoading: false,
  currentStep: 1,
};

PendingPayments.propTypes = {
  employees: PropTypes.array,
  content: PropTypes.object.isRequired,
  data: PropTypes.object,
  isLoading: PropTypes.bool,
  currentStep: PropTypes.number,
};
